import React from 'react';
import { connect } from 'react-redux';

export default (ComposedComponent) => {
  class Authentication extends React.Component {
    componentDidMount() {
      if (this.props.authenticated) {
        this.props.history.push('/');
      }
    }
    componentDidUpdate() {
      if (this.props.authenticated) {
        this.props.history.push('/');
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  const mapStateToProps = state => {
    return { authenticated: state.authentication.authenticated };
  }

  return connect(mapStateToProps)(Authentication);
}
